import { Head, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import EquipmentAssignmentForm from "./_form"

interface CaseRecord {
  id: number
  case_number: string
  display_name: string
}

interface AssignmentData {
  equipment_id: number | null
  user_id: number | null
  assigned_at: string | null
  start_odometer: number | null
  notes: string
  install_vehicle: string
  install_vehicle_location: string
  install_gps_location: string
}

interface EquipmentType {
  id: number
  name: string
  requires_location: boolean
}

interface EquipmentUnit {
  id: number
  name: string
  sort_name: string | null
  equipment_type_id: number | null
  equipment_type_name: string | null
  requires_odometer: boolean
  requires_location: boolean
  requires_vehicle: boolean
  current_assignee: string | null
}

interface User {
  id: number
  name: string
}

interface Props {
  case_record: CaseRecord
  assignment: AssignmentData
  equipment_types: EquipmentType[]
  equipment_units: EquipmentUnit[]
  users: User[]
  errors?: Record<string, string[]>
}

export default function New({
  case_record,
  assignment,
  equipment_types,
  equipment_units,
  users,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Cases", href: "/cases" },
    {
      title: case_record.display_name || case_record.case_number,
      href: `/cases/${case_record.id}`,
    },
    {
      title: "Equipment",
      href: `/cases/${case_record.id}/equipment_assignments`,
    },
    {
      title: "Assign",
      href: `/cases/${case_record.id}/equipment_assignments/new`,
    },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Assign Equipment - ${case_record.case_number}`} />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Assign Equipment</h1>

        <div className="rounded-lg bg-white p-6 shadow">
          <EquipmentAssignmentForm
            caseId={case_record.id}
            assignment={assignment}
            equipmentTypes={equipment_types}
            equipmentUnits={equipment_units}
            users={users}
            errors={errors}
            onCancel={() =>
              router.get(`/cases/${case_record.id}/equipment_assignments`)
            }
          />
        </div>
      </div>
    </AppLayout>
  )
}
